import * as PropertyDisplay from 'customer-data-property-utils/PropertyDisplay';
import { CTA, IMPORT, IN_LIST, UNIFIED_EVENT } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { useCallback, useContext } from 'react';
import { useStrategy } from './useStrategy';
import { getOperatorLabelTranslationKey } from '../utils/filterOperatorLabelTranslations';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import getIn from 'transmute/getIn';
import unescapedText from 'I18n/utils/unescapedText';
import { ASSET_TYPE_TOKENS } from 'customer-data-filters-ui/utils/filterAssetTypeTokens';
import { Map as ImmutableMap } from 'immutable';
import { hasFieldOverrideV2 } from '../permissions/gates';
import { DATE } from '../converters/listSegClassic/OperationTypes';
export const useTranslationHelpers = filterFamily => {
  const {
    data,
    getIsUngated,
    props: {
      translationPrefix
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getFieldDefinitions
  } = useStrategy();
  const getFieldLabelString = useCallback(field => {
    const hardcodedFieldDefinitions = hasFieldOverrideV2(getIsUngated) ? ImmutableMap({}) : getFieldDefinitions(filterFamily);
    const {
      name
    } = field || {};
    const getter = getIn([name, 'getLabelString'], hardcodedFieldDefinitions) || PropertyDisplay.getPropertyLabel;
    return getter(field);
  }, [filterFamily, getFieldDefinitions, getIsUngated]);
  const getOperatorLabelString = useCallback((Operator, field) => {
    return Operator.getLabel ? Operator.getLabel(field) : unescapedText(getOperatorLabelTranslationKey(Operator, field, filterFamily !== UNIFIED_EVENT && field.type !== DATE, translationPrefix));
  }, [filterFamily, translationPrefix]);
  const getFieldLabelStringByName = fieldName => {
    const field = data.getIn([filterFamily, fieldName]);
    if (field) {
      return getFieldLabelString(field);
    }
    return fieldName;
  };
  const getAssetTypeLabelToken = isValue => {
    if (filterFamily === CTA && isValue) {
      return 'CTA_VERSION';
    }
    if (filterFamily.startsWith(IMPORT)) {
      return ASSET_TYPE_TOKENS[IMPORT];
    }
    if (filterFamily.startsWith(IN_LIST)) {
      return ASSET_TYPE_TOKENS[IN_LIST];
    }
    return ASSET_TYPE_TOKENS[filterFamily];
  };
  return {
    getFieldLabelString,
    getOperatorLabelString,
    getFieldLabelStringByName,
    getAssetTypeLabelToken
  };
};